/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from 'react';
import http from 'utilities/http';
import Link from 'next/link';
import Image from 'next/image';
import { API_URL_V2, POST_TYPE_MAPPING } from '../../../utilities/constants';
import { isUndefined, set } from 'lodash';
import ArticleComponent, {
    ArticleSmall,
} from 'components/cong-dong/articleComponent';
import { getCookie } from 'framework/libs/cookie';
import { TOKEN_CONGDONG } from 'framework/store/constants';
import { isEmpty } from 'lodash';
import StarList from 'components/shop/review/starList';
import axios from 'axios';
import { Button, Col, Modal, Row, Space, Tabs, Flex, Empty } from 'antd';
import Paginate from 'components/home/paginate';
import { Loader } from 'components/loader';

export default function Index({ profession, activeTab = '' }) {
    return (
        <>
            <TabCategory professionId={profession.id} activeTab={activeTab} />
        </>
    );
}

const TAB_LIST = [
    'chuyện nhà',
    'kho ảnh',
    'review',
    'chợ đồ cũ',
    'thảo luận',
    'ăn chơi',
    'ăn - chơi',
];

export const CongTrinh = ({ professionId }) => {
    const [articles, setArticles] = useState([]);
    useEffect(() => {
        const fetch = async () => {
            try {
                const res = await axios.get(
                    API_URL_V2 + 'project-introduction',
                    {
                        params: {
                            per_page: 3,
                            professional_id: professionId,
                        },
                    },
                );
                if (!isEmpty(res.data.data)) {
                    setArticles(res.data.data);
                }
            } catch (e) {
                console.log(e);
            }
        };
        fetch();
    }, []);

    return (
        <>
            {!isEmpty(articles) && (
                <div
                    className="px-24px pt-24px m-px-16px m-ml--16px m-mr--16px position-relative border-radius-12 m-border-radius-0"
                    style={{
                        background: '#F0FBFF',
                        overflow: 'hidden',
                    }}
                >
                    <p className="font-size-20 font-weight-600 color-blue">
                        Công trình Happynest giới thiệu
                    </p>
                    <img
                        src="/chuyen-gia/box-cong-trinh.svg"
                        className="position-absolute pc-only"
                        style={{ top: 0, right: 0 }}
                    />
                    <Row className="mt-26px mb-24px" gutter={[20, 20]}>
                        {articles.map((item, index) => {
                            return (
                                <Col key={index} md={8} xs={24}>
                                    <ArticleSmall
                                        key={index}
                                        item={item}
                                        index={index}
                                        slug={'chuyen-nha'}
                                        isUserPage={false}
                                    />
                                </Col>
                            );
                        })}
                    </Row>
                    <Button
                        style={{
                            background: '#BDE8FF',
                            color: '#278FF7',
                            border: 'none',
                            borderRadius: 0,
                            width: 'calc(100% + 48px)',
                            height: 48,
                            marginLeft: '-24px',
                        }}
                    >
                        Xem tất cả
                    </Button>
                </div>
            )}
        </>
    );
};

export const TabCategory = ({ professionId, activeTab='' }) => {
    const [activeKey, setActiveKey] = useState(0);
    // ✅ Cập nhật activeKey khi prop activeTab thay đổi
    useEffect(() => {
        if (!isEmpty(activeTab)) {
            setActiveKey(activeTab);
        }
    }, [activeTab]);
    const [data, setData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const fetchData = async (page, slug) => {
        try {
            setIsLoading(true);
            const token = getCookie(TOKEN_CONGDONG);

            const config = {
                params: {
                    per_page: 6,
                    page: Number(page) || 1,
                },
                ...(token && {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }),
            };
            const res = await axios.get(
                API_URL_V2 +
                    `community/professional/${professionId}/article-categories`,
                config,
            );
            if (res.data.success == false) return;
            const thisData = res.data.data.filter((item) => {
                return TAB_LIST.includes(
                    item.category?.data?.name.toLowerCase(),
                );
            });
            // Nếu có param slug thì update mỗi slug đó thôi
            if (slug) {
                const result = { ...data };
                thisData.forEach((item, index) => {
                    const slugApi = item.category?.data?.slug;
                    if(slugApi === slug){
                        result[slug] = {
                            index: index,
                            name: item.category?.data?.name,
                            slug: slug,
                            posts: item.posts?.data || [],
                            meta: item.posts?.meta || {},
                        };
                    }

                });
                // const thisData1 = thisData.find((item) => {
                //     return item.category?.data?.slug == slug;
                // });
                // result[slug] = {
                //     name: thisData1.category?.data?.name,
                //     slug: slug,
                //     posts: thisData1.posts?.data || [],
                //     meta: thisData1.posts?.meta || {},
                // };
                setData(result);
                return;
            }
            const result = {};
            thisData.forEach((item, index) => {
                const slug = item.category?.data?.slug;
                result[slug] = {
                    index: index,
                    name: item.category?.data?.name,
                    slug: slug,
                    posts: item.posts?.data || [],
                    meta: item.posts?.meta || {},
                };
            });
            setData(result);
        } catch (e) {
            console.log(e);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const total = Object.values(data).reduce((a, b) => {
        return a + b.meta.pagination.total;
    }, 0);

    const items = [
        {
            key: 0,
            label: (
                <>
                    <span className="font-size-14 color-444">Tất cả</span>{' '}
                    {!!total && (
                        <span className="color-primary">({total})</span>
                    )}
                </>
            ),
            children: (
                <>
                    <Space direction="vertical" size={20} className="w-100">
                        <CongTrinh professionId={professionId} />
                        {Object.values(data).map((item, index) => {
                            return (
                                <>
                                    {!isEmpty(item.posts) && (
                                        <div
                                            className="bb-sp mb-sm-0 mb-4 pt-0 pb-3 main--photoStore anchor-link"
                                            id="chuyen-nha"
                                        >
                                            <div className="groupCategory-title">
                                                <Flex
                                                    align="center"
                                                    justify="space-between"
                                                    className="w-100"
                                                >
                                                    <h3 className="groupCategory-tlt">
                                                        {item.name}
                                                    </h3>
                                                    <p
                                                        className="color-primary cursor-pointer"
                                                        onClick={() =>
                                                            setActiveKey(
                                                                item.slug,
                                                            )
                                                        }
                                                    >
                                                        Xem tất cả
                                                    </p>
                                                </Flex>
                                            </div>
                                            <div className="lstPhoto">
                                                <ul>
                                                    {item.posts.map(
                                                        (article, index) => {
                                                            const perRow =
                                                                item.slug ===
                                                                'kho-360'
                                                                    ? 3
                                                                    : 2;
                                                            return (
                                                                <ArticleComponent
                                                                    key={index}
                                                                    item={
                                                                        article
                                                                    }
                                                                    index={
                                                                        index
                                                                    }
                                                                    slug={
                                                                        item.slug ===
                                                                        'kho-anh'
                                                                            ? 'album'
                                                                            : item.slug
                                                                    }
                                                                    isUserPage={
                                                                        true
                                                                    }
                                                                    perRow={
                                                                        perRow
                                                                    }
                                                                />
                                                            );
                                                        },
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                </>
                            );
                        })}
                        {total == 0 && (
                            <Empty
                                style={{
                                    height: '300px',
                                    paddingTop: '60px',
                                }}
                                description="Chưa có bài viết"
                            />
                        )}
                    </Space>
                </>
            ),
        },
    ].concat(
        Object.values(data).map((item, index) => {
            return {
                key: item.slug,
                label: (
                    <>
                        <span className="font-size-14 font-weight-400 color-444">
                            {item.name}
                        </span>{' '}
                        {!!item.meta.pagination.total && (
                            <span className="color-primary">
                                ({item.meta.pagination.total})
                            </span>
                        )}
                    </>
                ),
                children: (
                    <>
                        {!isEmpty(item.posts) && (
                            <div
                                className="bb-sp mb-sm-0 mb-4 pt-0 pb-3 main--photoStore anchor-link"
                                id="chuyen-nha"
                            >
                                <div className="groupCategory-title">
                                    <h3 className="groupCategory-tlt">
                                        {item.name}
                                        {/* <span className="c-blue">{articlesBV?.data?.length}</span> */}
                                    </h3>
                                </div>
                                <div className="lstPhoto">
                                    <ul>
                                        {item.posts.map((article, index) => {
                                            const perRow =
                                                item.slug === 'kho-360' ? 3 : 2;
                                            return (
                                                <ArticleComponent
                                                    key={index}
                                                    item={article}
                                                    index={index}
                                                    slug={
                                                        item.slug === 'kho-anh'
                                                            ? 'album'
                                                            : item.slug
                                                    }
                                                    isUserPage={true}
                                                    perRow={perRow}
                                                />
                                            );
                                        })}
                                    </ul>
                                    <Paginate
                                        paginate={[
                                            6,
                                            item.meta?.pagination?.total || 0,
                                        ]}
                                        fetchData={(page) =>
                                            fetchData(page, item.slug)
                                        }
                                        scrollToEl="#chuyen-nha"
                                        haveInit={true}
                                    ></Paginate>
                                </div>
                            </div>
                        )}
                        {isEmpty(item.posts) && (
                            <>
                                <div
                                    className="bb-sp mb-sm-0 mb-4 pt-0 pb-3 main--photoStore anchor-link"
                                    id="chuyen-nha"
                                >
                                    <Empty
                                        style={{
                                            height: '300px',
                                            paddingTop: '60px',
                                        }}
                                        description="Chưa có bài viết"
                                    />
                                </div>
                            </>
                        )}
                    </>
                ),
            };
        }),
    );

    const onChange = (key) => {
        setActiveKey(key);
    };
    return (
        <>
            <Loader loading={isLoading} />
            <Tabs activeKey={activeKey} items={items} onChange={onChange} />
        </>
    );
};
